export default __webpack_public_path__ + "static/17-594473eba87164c3041b36d69ee39cc8.webp";